import { I18n } from '@/services/i18n';

type Message = {
  paySafe: string;
  hint: string;
  policy: string;
  see: string;
  forDetails: string;
};

const messages: I18n<Message> = {
  en: {
    paySafe: 'Pay safe and secure',
    hint: 'By clicking "{discount}", you agree to the subscription automatic renewal. First {label} {packageSelectedPriceFormatted}, then {packageSelectedPriceNextFormatted}/{label} unless canceled at least 24 hours before the period ends. Additional purchases available. Cancel anytime via ',
    policy: 'Membership and Refund Policy',
    see: 'See',
    forDetails: 'for details',
  },
  es: {
    paySafe: 'Pague de forma segura y protegida',
    hint: 'Al hacer clic en "{discount}", acepta la renovación automática de la suscripción. Primer {label} {packageSelectedPriceFormatted}, luego {packageSelectedPriceNextFormatted}/{label} a menos que se cancele al menos 24 horas antes de que termine el período. Compras adicionales disponibles. Cancelar en cualquier momento a través de ',
    policy: 'Política de Membresía y Reembolso',
    see: 'Ver',
    forDetails: 'para más detalles',
  },
  de: {
    paySafe: 'Sicher und geschützt zahlen',
    hint: 'Durch Klicken auf "{discount}" stimmen Sie der automatischen Verlängerung des Abonnements zu. Erster {label} {packageSelectedPriceFormatted}, dann {packageSelectedPriceNextFormatted}/{label}, es sei denn, Sie kündigen mindestens 24 Stunden vor Ablauf des Zeitraums. Zusätzliche Käufe verfügbar. Jederzeit kündigen über ',
    policy: 'Mitgliedschafts- und Rückerstattungsrichtlinie',
    see: 'Siehe',
    forDetails: 'für Details',
  },
};

export { messages };
